import React from 'react';

type IProps = {
  children: React.ReactNode;
  className?: string;
};

const ButtonContainer: React.FC<IProps> = ({ children, className = '' }) => (
  <div className={`bs-input-container ${className}`}>{children}</div>
);

export default ButtonContainer;
